package gr.tech.GRAttestation.pages.admin.login

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.components.layouts.AdminPageLayout
import gr.tech.GRAttestation.navigation.AdminSitePage
import gr.tech.GRAttestation.styles.grstyles.LoginPageButtonStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import gr.tech.GRAttestation.util.ROUTES
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

/*
    Login Page Information:
    - Description here
 */

@Page()
@Composable
fun UserLoginPage() {
    AdminPageLayout(
        title = "Login",
        redirectIfLoggedIn = AdminSitePage.Home.route,
        showNav = false,
        requiredRoles = emptyList()
    ) {
        UserLoginScreen()
    }
}

@Composable
fun UserLoginScreen() {
    var errorText by remember { mutableStateOf(" ") }

    Box(
        modifier = Modifier.fillMaxSize().backgroundColor(Theme.HalfBlack.rgb),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .padding(all = 50.px)
                .borderRadius(6.px)
                .backgroundColor(Colors.WhiteSmoke),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            H1(
                Modifier
                    .margin(bottom = 25.px)
                    .classNames("title").toAttrs()
            ) {
                Text("Login")
            }

            HorizontalDivider(Modifier.margin(bottom = 25.px))

            //Sign In
            A(
                href = ROUTES.BACKEND.AUTH.USER_OAUTH_LOGIN,
                attrs = LoginPageButtonStyle.toModifier()
                    .margin(bottom = 24.px)
                    .toAttrs()
            ) {
                Img(
                    src = "/googleIcon.svg",
                    alt = "Google Icon",
                    attrs = Modifier.width(45.px).height(autoLength).margin(right = 10.px).toAttrs(),
                )
                SpanText(text = "Sign in with Google", modifier = Modifier.fillMaxWidth().color(Colors.Black).textAlign(TextAlign.Center))
            }



            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .fontFamily(FONT_FAMILY)
                    .color(Colors.Red)
                    .margin(
                        bottom = 12.px
                    )
                    .textAlign(TextAlign.Center),
                text = errorText
            )
        }
    }
}
